import { render, staticRenderFns } from "./AmeldingContact.vue?vue&type=template&id=2d92d00d&scoped=true&"
import script from "./AmeldingContact.vue?vue&type=script&lang=ts&"
export * from "./AmeldingContact.vue?vue&type=script&lang=ts&"
import style0 from "./AmeldingContact.vue?vue&type=style&index=0&id=2d92d00d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d92d00d",
  null
  
)

export default component.exports